var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"home-banner",on:{"click":_vm.click}},[_c('img',{staticClass:"w-100",attrs:{"src":_vm.showcase.cover_web}})])
}
var staticRenderFns = []

export { render, staticRenderFns }